import { useState, useEffect } from "react";
import { useQuery, ApolloError } from "@apollo/client";
import { getDowntimeMethodCapture } from "../../api/queries/downtimeMethodCaptureAPI";
import { IDowntimeMethodCapture, IDowntimeMethodCapturesEntity } from "./DowntimeMethodCapturesInterfaces";

export const DowntimeMethodCapturesEntity: IDowntimeMethodCapturesEntity = {
    GetDowntimeMethodCapture: () => {
        const { loading, error, data, refetch } = useQuery(getDowntimeMethodCapture);
        const [downtimeMethodCaptures, setDowntimeMethodCaptures] = useState<IDowntimeMethodCapture[]>([]);
        const [apolloQueryError, setApolloQueryError] = useState<ApolloError | undefined>(undefined);

        useEffect(() => {
            if (data) {
                const downtimeMethodCapturesArray: IDowntimeMethodCapture[] = data.downtime_method_capture;
                setDowntimeMethodCaptures(downtimeMethodCapturesArray);
            }
            if (error) {
                setApolloQueryError(error);
            }
        }, [data, error]);

        return { loading, downtimeMethodCaptures, apolloQueryError, refetch };
    },
};
